import React from "react";
import { Outlet } from "react-router-dom";
import NavMenu from "../NavMenu/index";

function Layout() {
  return (
    <div className="d-flex">
      <NavMenu />
      <Outlet />
    </div>
  );
}

export default Layout;
